import {
  ChangeDetectorRef,
  EventEmitter,
  Directive,
  AfterViewInit,
  inject,
} from '@angular/core';
import { Column } from '../../../shared/components/sep-table/Column';
import { LanguageService } from '../../../core/services/language.service';
import { StudentEligibleForEnrollmentBaseUIModel } from './EnrolledStudentBaseUIModel';

@Directive()
export abstract class EnrollmentTableBaseComponent implements AfterViewInit {
  protected readonly cdr = inject(ChangeDetectorRef);
  protected readonly languageService = inject(LanguageService);

  columns: Array<
    Column<
      StudentEligibleForEnrollmentBaseUIModel,
      string | { $implicit: string }
    >
  > = [
    {
      headerName: this.getTranslation('nameAndEmail'),
      renderComponent: undefined,
      key: 'username',
    },
  ];
  abstract students: StudentEligibleForEnrollmentBaseUIModel[];
  abstract primaryButtonClickEvent: EventEmitter<void>;

  ngAfterViewInit(): void {
    this.configureColumns();
    this.cdr.detectChanges();
  }

  primaryButtonClick(): void {
    this.primaryButtonClickEvent.emit();
  }

  protected getTranslation(key: string): string {
    return this.languageService.translateOnRuntime(
      'portal.users.table.header.' + key,
    );
  }

  protected abstract configureColumns(): void;
}
